@if (phase() !== null) {
  <!-- takes over from onboarding's last step at the same place; the
       dashboard lies tilted below it (the layout reads phase()), and the
       message fades out as the dashboard flips up; the stage is the live
       region -->
  <div
    class="fixed inset-0 z-50 flex flex-col transition-opacity duration-500 ease-out motion-reduce:transition-none"
    [ngClass]="{ 'pointer-events-none opacity-0': phase() === 'entering' }">
    <app-welcome-stage>
      <span stageTitle>{{ 'pages.onboarding.ready.title' | transloco }}</span>
      <span stageDescription>
        {{ 'pages.onboarding.ready.description' | transloco }}
      </span>

      <!-- the loader's button: a dark indigo track that fills up, then
           the dashboard opens on its own -->
      <button
        type="button"
        class="relative isolate h-9.25 cursor-pointer overflow-hidden rounded-[10px] bg-accent-900 px-4 text-sm tracking-[-0.03em] text-zinc-100 outline-none focus-visible:ring-2 focus-visible:ring-accent-400"
        (click)="enter()">
        @if (phase() === 'preview' || phase() === 'entering') {
          <span
            class="absolute inset-0 -z-10 origin-left animate-fill-x bg-accent-500 motion-reduce:animate-none"
            aria-hidden="true"></span>
        }
        {{ 'pages.onboarding.ready.enter' | transloco }}
      </button>
    </app-welcome-stage>
  </div>
}
